import { ChangeDetectionStrategy, Component, inject, signal, effect } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { VehicleService } from '../../services/vehicle.service';
import { RecommendationService } from '../../services/recommendation.service';
import { ToastService } from '../../services/toast.service';
import { NlCurrencyPipe } from '../pipes/nl-currency.pipe';

@Component({
  selector: 'app-direct-buy-modal',
  imports: [IconComponent, NlCurrencyPipe],
  templateUrl: './direct-buy-modal.component.html',
  styleUrl: './direct-buy-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DirectBuyModalComponent {
  public readonly vs = inject(VehicleService);
  private readonly recommendationService = inject(RecommendationService);
  private readonly toastService = inject(ToastService);

  public readonly confirmingBuy = signal(false);
  public readonly buying = signal(false);
  public readonly closing = signal(false);

  constructor() {
    // Reset confirmation state whenever the modal closes, however it closes
    // (e.g. the global Escape shortcut calls vehicleService.closeDirectBuyModal()
    // directly, bypassing this component's own close()).
    effect(() => {
      if (!this.vs.currentDirectBuyVehicle()) {
        this.confirmingBuy.set(false);
      }
    });
  }

  public get vatLabel(): string {
    return this.vs.currentDirectBuyVehicle()?.VehicleSpecification?.VatMarginType?.name === 'vat' ? 'incl. BTW' : 'Marge';
  }

  public initiateBuy(): void {
    this.confirmingBuy.set(true);
  }

  public cancelBuy(): void {
    this.confirmingBuy.set(false);
  }

  public confirmBuy(): void {
    const v = this.vs.currentDirectBuyVehicle();
    if (!v || this.buying()) return;

    const recommendationId = v.Recommendation?.id;
    if (!recommendationId) {
      this.toastService.show('Direct kopen is niet beschikbaar voor dit voertuig', 'error');
      this.close();
      return;
    }

    this.buying.set(true);
    this.recommendationService.buy(recommendationId, v.id).subscribe({
      next: () => {
        this.buying.set(false);
        this.close();
        this.vs.reloadSilent();
      },
      error: () => this.buying.set(false)
    });
  }

  public close(): void {
    if (this.closing()) return;
    this.closing.set(true);
    setTimeout(() => {
      this.vs.closeDirectBuyModal();
      this.confirmingBuy.set(false);
      this.closing.set(false);
    }, 200);
  }
}
